module.exports = __webpack_public_path__ + "img/slide_pc_2.698eebca.png";